import { render, staticRenderFns } from "./assessment-panel.vue?vue&type=template&id=3914240d&scoped=true&"
import script from "./assessment-panel.vue?vue&type=script&lang=ts&"
export * from "./assessment-panel.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-panel.vue?vue&type=style&index=0&id=3914240d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914240d",
  null
  
)

export default component.exports